import { Component } from '@angular/core';
import { PairCodeInputComponent } from '../../../features/devices/components/pair-code-input/pair-code-input.component';

@Component({
  selector: 'era-pair-page',
  templateUrl: './pair.page.html',
  styleUrls: ['./pair.page.scss'],
  imports: [PairCodeInputComponent],
})
export class PairPage {}
